import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/student-galleries-bk', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/student-galleries-bk', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const update = data => {
    return httpClient
        .put(`/api/student-galleries-bk/${data.upload_id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
    return httpClient
        .delete(`/api/student-galleries-bk/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const download = id => {
    return httpClient
        .get(`/api/student-galleries-bk/downloads/${id}`, {
            responseType: 'arraybuffer'
        })
        .then(response => Promise.resolve(response.data))
        .catch(response => Promise.reject(response.data))
}
export const removePhoto = id => {
    return httpClient
        .get(`/api/student-galleries-bk/remove-photos/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(response => Promise.reject(response.data))
}
export const removeFile = (Options = {}) => {
    return httpClient
        .get('/api/student-galleries-bk/remove-files', Options)
        .then(response => Promise.resolve(response.data))
        .catch(response => Promise.reject(response.data))
}
export default {
    get,
    store,
    update,
    destroy,
    download,
    removePhoto,
    removeFile
}
